import { gtag } from '../src/libs/analytics';
import { maskNumber } from './helpers';

function callGoogleAnalytics(event) {
  event.preventDefault();
  var type = document.getElementById("inquiry_type").value;
  var reason = document.getElementById("inquiry_reason").value;
  gtag('event', 'contact_page_form_submit', {
    'page_title': 'Contact Us - Support',
    'inquiry_type': type,
    'inquiry_reason': reason
  });
  document.getElementById("contact_form").submit();
}


document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('contact_phone').addEventListener('blur', maskNumber);
    
    document.getElementById("contact_form").addEventListener("submit", callGoogleAnalytics);

    var inquiryObject = {
      'HomeBridge Account Support': [ 'Forgot Password', 'User Locked', 'Other' ],
      'General Inquiry': [ 'General Inquiry' ],
      'Feedback/Suggestions': [ 'Feedback/Suggestions' ]
    }

    var typeSel = document.getElementById("inquiry_type");
    var reasonSel = document.getElementById("inquiry_reason");

    typeSel.length = 1;
    for (var type in inquiryObject) {
      typeSel.options[typeSel.options.length] = new Option(type, type)
    }

    typeSel.onchange = function () {
      reasonSel.length = 1;
      if (this.selectedIndex < 1) return;
      var reasons =  inquiryObject[typeSel.value];
      for (var i = 0 ; i < reasons.length ; i++ ) {
        reasonSel.options[reasonSel.options.length] = new Option(reasons[i], reasons[i], false, reasons.length < 2);
      }
    }
  });